import clsx from 'clsx';
import React, { ReactNode, useMemo } from 'react';
import { FieldError } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

import { Status } from '@/models/form/form';
import { handleStatus } from '@/utils/form';

interface IProps {
  children: ReactNode;
  disabled?: boolean;
  error?: FieldError;
  focused?: boolean;
  value?: string;
  touched?: boolean;
  shouldShow?: boolean;
}
const FormBorderWrapper = ({
  disabled = false,
  focused = false,
  error = undefined,
  shouldShow = true,
  touched = false,
  value = '',
  children,
}: IProps) => {
  const status = useMemo(
    () => handleStatus(focused!, error, touched!, value),
    [focused, error, touched, value]
  );
  return (
    <div
      className={
        shouldShow
          ? twMerge(
              clsx(
                focused && 'ring-2',
                !focused && !error && 'border-gray-50 hover:border-gray-60',
                status === Status.SUCCESS &&
                  touched &&
                  'border-b-2 border-green-50',
                status === Status.ERROR && 'ring-2 ring-red-utility',
                status === Status.FOCUSED && 'ring-blue-60',
                'border-b-2 transition-all duration-150',
                // Autocalulated fields do not "appear" as disabled
                disabled && 'border-gray-50 opacity-30'
              )
            )
          : ''
      }
    >
      {children}
    </div>
  );
};

export default FormBorderWrapper;
